import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import PreLoader from './core/components/core/Layout/PreLoader/PreLoader';
import CoreRoutes from './core/routes/CoreRoutes';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import ApplicationRoutes from './application/routes/Routes';
import { loadState, saveState } from './core/store/SessionStore';
import { rootReducer } from './core/reducers/core';
import { fetchEncryptedKeysThunk } from './core/store/KeysThunk';
import thunk from 'redux-thunk';
import { SocketProvider } from './core/contexts/SocketContext';

const store = createStore(rootReducer, loadState(), applyMiddleware(thunk));

store.dispatch(fetchEncryptedKeysThunk());

store.subscribe(() => {
    saveState(store.getState());
});

function App() {
  return (
    <Provider store={store}>
        <SocketProvider>
          <Router>
              <PreLoader />
              <CoreRoutes/>
              <ApplicationRoutes />
          </Router>
        </SocketProvider>
      </Provider>
  );
}

export default App;